// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file artifacts/analyzer/v1/analyzer_service.proto (package artifacts.analyzer.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AnalysisResult } from "../../../controls/v1/analysis_result_pb";
import { file_controls_v1_analysis_result } from "../../../controls/v1/analysis_result_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file artifacts/analyzer/v1/analyzer_service.proto.
 */
export const file_artifacts_analyzer_v1_analyzer_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_controls_v1_analysis_result]);

/**
 * @generated from message artifacts.analyzer.v1.ListSubcategoriesRequest
 */
export type ListSubcategoriesRequest = Message<"artifacts.analyzer.v1.ListSubcategoriesRequest"> & {
};

/**
 * Describes the message artifacts.analyzer.v1.ListSubcategoriesRequest.
 * Use `create(ListSubcategoriesRequestSchema)` to create a new message.
 */
export const ListSubcategoriesRequestSchema: GenMessage<ListSubcategoriesRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 0);

/**
 * @generated from message artifacts.analyzer.v1.ListSubcategoriesResponse
 */
export type ListSubcategoriesResponse = Message<"artifacts.analyzer.v1.ListSubcategoriesResponse"> & {
  /**
   * @generated from field: repeated artifacts.analyzer.v1.CategoryMetadata categories = 1;
   */
  categories: CategoryMetadata[];
};

/**
 * Describes the message artifacts.analyzer.v1.ListSubcategoriesResponse.
 * Use `create(ListSubcategoriesResponseSchema)` to create a new message.
 */
export const ListSubcategoriesResponseSchema: GenMessage<ListSubcategoriesResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 1);

/**
 * @generated from message artifacts.analyzer.v1.CategoryMetadata
 */
export type CategoryMetadata = Message<"artifacts.analyzer.v1.CategoryMetadata"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string category = 2;
   */
  category: string;

  /**
   * @generated from field: string subcategory = 3;
   */
  subcategory: string;
};

/**
 * Describes the message artifacts.analyzer.v1.CategoryMetadata.
 * Use `create(CategoryMetadataSchema)` to create a new message.
 */
export const CategoryMetadataSchema: GenMessage<CategoryMetadata> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 2);

/**
 * @generated from message artifacts.analyzer.v1.UpdateArtifactSubcategoryRequest
 */
export type UpdateArtifactSubcategoryRequest = Message<"artifacts.analyzer.v1.UpdateArtifactSubcategoryRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string sub_category_id = 2;
   */
  subCategoryId: string;
};

/**
 * Describes the message artifacts.analyzer.v1.UpdateArtifactSubcategoryRequest.
 * Use `create(UpdateArtifactSubcategoryRequestSchema)` to create a new message.
 */
export const UpdateArtifactSubcategoryRequestSchema: GenMessage<UpdateArtifactSubcategoryRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 3);

/**
 * @generated from message artifacts.analyzer.v1.UpdateArtifactSubcategoryResponse
 */
export type UpdateArtifactSubcategoryResponse = Message<"artifacts.analyzer.v1.UpdateArtifactSubcategoryResponse"> & {
};

/**
 * Describes the message artifacts.analyzer.v1.UpdateArtifactSubcategoryResponse.
 * Use `create(UpdateArtifactSubcategoryResponseSchema)` to create a new message.
 */
export const UpdateArtifactSubcategoryResponseSchema: GenMessage<UpdateArtifactSubcategoryResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 4);

/**
 * @generated from message artifacts.analyzer.v1.RunPromptOnCompanyRequest
 */
export type RunPromptOnCompanyRequest = Message<"artifacts.analyzer.v1.RunPromptOnCompanyRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string prompt = 2;
   */
  prompt: string;

  /**
   * @generated from field: repeated string subcategory_allow_list_ids = 3;
   */
  subcategoryAllowListIds: string[];

  /**
   * @generated from field: repeated string search_queries = 4;
   */
  searchQueries: string[];
};

/**
 * Describes the message artifacts.analyzer.v1.RunPromptOnCompanyRequest.
 * Use `create(RunPromptOnCompanyRequestSchema)` to create a new message.
 */
export const RunPromptOnCompanyRequestSchema: GenMessage<RunPromptOnCompanyRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 5);

/**
 * @generated from message artifacts.analyzer.v1.RunPromptOnCompanyResponse
 */
export type RunPromptOnCompanyResponse = Message<"artifacts.analyzer.v1.RunPromptOnCompanyResponse"> & {
  /**
   * @generated from field: controls.v1.AnalysisResult analysis_result = 1;
   */
  analysisResult?: AnalysisResult;
};

/**
 * Describes the message artifacts.analyzer.v1.RunPromptOnCompanyResponse.
 * Use `create(RunPromptOnCompanyResponseSchema)` to create a new message.
 */
export const RunPromptOnCompanyResponseSchema: GenMessage<RunPromptOnCompanyResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 6);

/**
 * @generated from message artifacts.analyzer.v1.ForceAnalyzeControlRequest
 */
export type ForceAnalyzeControlRequest = Message<"artifacts.analyzer.v1.ForceAnalyzeControlRequest"> & {
  /**
   * @generated from field: string org_control_definition_id = 2;
   */
  orgControlDefinitionId: string;

  /**
   * @generated from field: string org_ongoing_assessment_id = 3;
   */
  orgOngoingAssessmentId: string;
};

/**
 * Describes the message artifacts.analyzer.v1.ForceAnalyzeControlRequest.
 * Use `create(ForceAnalyzeControlRequestSchema)` to create a new message.
 */
export const ForceAnalyzeControlRequestSchema: GenMessage<ForceAnalyzeControlRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 7);

/**
 * Returns immediately after triggering analysis
 * Results will be saved to org_control_responses
 *
 * @generated from message artifacts.analyzer.v1.ForceAnalyzeControlResponse
 */
export type ForceAnalyzeControlResponse = Message<"artifacts.analyzer.v1.ForceAnalyzeControlResponse"> & {
};

/**
 * Describes the message artifacts.analyzer.v1.ForceAnalyzeControlResponse.
 * Use `create(ForceAnalyzeControlResponseSchema)` to create a new message.
 */
export const ForceAnalyzeControlResponseSchema: GenMessage<ForceAnalyzeControlResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 8);

/**
 * @generated from message artifacts.analyzer.v1.ReanalyzeAssessmentControlsRequest
 */
export type ReanalyzeAssessmentControlsRequest = Message<"artifacts.analyzer.v1.ReanalyzeAssessmentControlsRequest"> & {
  /**
   * @generated from field: string org_ongoing_assessment_id = 1;
   */
  orgOngoingAssessmentId: string;
};

/**
 * Describes the message artifacts.analyzer.v1.ReanalyzeAssessmentControlsRequest.
 * Use `create(ReanalyzeAssessmentControlsRequestSchema)` to create a new message.
 */
export const ReanalyzeAssessmentControlsRequestSchema: GenMessage<ReanalyzeAssessmentControlsRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 9);

/**
 * @generated from message artifacts.analyzer.v1.ReanalyzeAssessmentControlsResponse
 */
export type ReanalyzeAssessmentControlsResponse = Message<"artifacts.analyzer.v1.ReanalyzeAssessmentControlsResponse"> & {
  /**
   * @generated from field: int32 controls_queued = 1;
   */
  controlsQueued: number;
};

/**
 * Describes the message artifacts.analyzer.v1.ReanalyzeAssessmentControlsResponse.
 * Use `create(ReanalyzeAssessmentControlsResponseSchema)` to create a new message.
 */
export const ReanalyzeAssessmentControlsResponseSchema: GenMessage<ReanalyzeAssessmentControlsResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 10);

/**
 * @generated from message artifacts.analyzer.v1.IndexCompanyResourcesRequest
 */
export type IndexCompanyResourcesRequest = Message<"artifacts.analyzer.v1.IndexCompanyResourcesRequest"> & {
  /**
   * @generated from oneof artifacts.analyzer.v1.IndexCompanyResourcesRequest.subject
   */
  subject: {
    /**
     * A tracked third party: the org's documents about it and the vendor's public ones.
     *
     * @generated from field: string org_company_id = 1;
     */
    value: string;
    case: "orgCompanyId";
  } | {
    /**
     * A catalogue vendor no org tracks yet: its public documents only.
     *
     * @generated from field: string company_id = 2;
     */
    value: string;
    case: "companyId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message artifacts.analyzer.v1.IndexCompanyResourcesRequest.
 * Use `create(IndexCompanyResourcesRequestSchema)` to create a new message.
 */
export const IndexCompanyResourcesRequestSchema: GenMessage<IndexCompanyResourcesRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 11);

/**
 * What the subject's search may cover: every document the call selected, by kind.
 *
 * @generated from message artifacts.analyzer.v1.IndexCompanyResourcesResponse
 */
export type IndexCompanyResourcesResponse = Message<"artifacts.analyzer.v1.IndexCompanyResourcesResponse"> & {
  /**
   * @generated from field: repeated string artifact_revision_ids = 1;
   */
  artifactRevisionIds: string[];

  /**
   * @generated from field: repeated string org_document_ids = 2;
   */
  orgDocumentIds: string[];

  /**
   * @generated from field: repeated string org_questionnaire_ids = 3;
   */
  orgQuestionnaireIds: string[];

  /**
   * @generated from field: repeated string org_procurement_questionnaire_ids = 4;
   */
  orgProcurementQuestionnaireIds: string[];
};

/**
 * Describes the message artifacts.analyzer.v1.IndexCompanyResourcesResponse.
 * Use `create(IndexCompanyResourcesResponseSchema)` to create a new message.
 */
export const IndexCompanyResourcesResponseSchema: GenMessage<IndexCompanyResourcesResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_analyzer_v1_analyzer_service, 12);

/**
 * @generated from service artifacts.analyzer.v1.AnalyzerService
 */
export const AnalyzerService: GenService<{
  /**
   * @generated from rpc artifacts.analyzer.v1.AnalyzerService.ListSubcategories
   */
  listSubcategories: {
    methodKind: "unary";
    input: typeof ListSubcategoriesRequestSchema;
    output: typeof ListSubcategoriesResponseSchema;
  },
  /**
   * @generated from rpc artifacts.analyzer.v1.AnalyzerService.UpdateArtifactSubcategory
   */
  updateArtifactSubcategory: {
    methodKind: "unary";
    input: typeof UpdateArtifactSubcategoryRequestSchema;
    output: typeof UpdateArtifactSubcategoryResponseSchema;
  },
  /**
   * @generated from rpc artifacts.analyzer.v1.AnalyzerService.RunPromptOnCompany
   */
  runPromptOnCompany: {
    methodKind: "unary";
    input: typeof RunPromptOnCompanyRequestSchema;
    output: typeof RunPromptOnCompanyResponseSchema;
  },
  /**
   * Support-only: queue analysis of a specific control, bypassing scope/enabled checks
   *
   * @generated from rpc artifacts.analyzer.v1.AnalyzerService.ForceAnalyzeControl
   */
  forceAnalyzeControl: {
    methodKind: "unary";
    input: typeof ForceAnalyzeControlRequestSchema;
    output: typeof ForceAnalyzeControlResponseSchema;
  },
  /**
   * Support-only: queue analysis of every enabled LLM control of an open assessment
   *
   * @generated from rpc artifacts.analyzer.v1.AnalyzerService.ReanalyzeAssessmentControls
   */
  reanalyzeAssessmentControls: {
    methodKind: "unary";
    input: typeof ReanalyzeAssessmentControlsRequestSchema;
    output: typeof ReanalyzeAssessmentControlsResponseSchema;
  },
  /**
   * Support-only: load a third party's documents into the vector store, skipping those already there.
   * Threat-scenario evaluation calls it before the agent searches them.
   *
   * @generated from rpc artifacts.analyzer.v1.AnalyzerService.IndexCompanyResources
   */
  indexCompanyResources: {
    methodKind: "unary";
    input: typeof IndexCompanyResourcesRequestSchema;
    output: typeof IndexCompanyResourcesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_artifacts_analyzer_v1_analyzer_service, 0);

